import { Link } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { default as Inflow } from "@/assets/logos/inflow/inflow-royal.svg"
import { IconButton } from "@/globalComponents/atoms/Button"
import { useTheme } from "@/utilities/hooks/useTheme"
import useToggle from "@/utilities/hooks/useToggle"

import Drawer from "./Drawer"

function TopNavigationBar() {
  const { documentThemeMode, scannedArea, uiScheme } = useTheme()

  const [isOpen, toggleIsOpen] = useToggle()
  const { t } = useTranslation(["welcome", "common"])

  const whiteLabel =
    documentThemeMode === "whiteLabel" ? scannedArea : undefined

  // Get theme data for welcome header
  const theme = scannedArea?.theme
  // const locationName = theme?.locationInformation?.locationName

  //   const addressObject = theme?.locationInformation?.address
  //   const address =
  //     typeof addressObject === "string"
  //       ? addressObject
  //       : addressObject?.address || "No Address Available"

  //   // Build Google Maps URL based on priority: coordinates > placeID > address
  //   let mapsUrl = ""
  //   if (
  //     typeof addressObject === "object" &&
  //     addressObject?.coordinates?.lat &&
  //     addressObject?.coordinates?.lng
  //   ) {
  //     // Use coordinates if available
  //     mapsUrl = `https://www.google.com/maps/search/?api=1&query=${addressObject.coordinates.lat},${addressObject.coordinates.lng}`
  //   } else if (typeof addressObject === "object" && addressObject?.placeID) {
  //     // Use placeID if coordinates not available
  //     mapsUrl = `https://www.google.com/maps/search/?api=1&query_place_id=${addressObject.placeID}`
  //   } else {
  //     // Fall back to address string
  //     mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`
  //   }
  //       {/* Address */}
  //       <a
  //         href={mapsUrl}
  //         target="_blank"
  //         rel="noopener noreferrer"
  //         className={styles.addressLink}
  //       >
  // Normal navigation bar
  return (
    <>
      <nav
        className="nav-top-bar"
        aria-label={t("navigation.mainMenu", { ns: "common" })}
      >
        {whiteLabel?.theme[uiScheme].logoURLs.main ? (
          <Link
            to="/qr/$qrLookupID/welcome"
            params={whiteLabel}
            className="nav-top-bar--logo"
          >
            <img
              src={whiteLabel?.theme[uiScheme].logoURLs.main}
              alt={theme?.locationInformation?.locationName || "Logo"}
            />
          </Link>
        ) : (
          <Link to="/" className="nav-top-bar--logo">
            <Inflow />
          </Link>
        )}

        <IconButton
          buttonType="primary"
          presentation="ghost"
          iconName="hamburger"
          aria-label={t("navigation.openMenu", { ns: "common" })}
          onPress={toggleIsOpen}
        />
      </nav>
      <Drawer isOpen={isOpen} onOpenChange={toggleIsOpen} />
    </>
  )
}
export default TopNavigationBar
